<template>
  <div>
    <base-header class="pb-6" type="">
      <div class="row align-items-center py-4">
        <!-- <div class="col-lg-6 col-7">
          <h6 class="h2 d-inline-block mb-0">Dashboard</h6>
        </div> -->
      </div>

      <!-- EJEMPLO CARD MOLON -->
      <div class="row">
        <!--  CARD NO APTOS -->
        <div class="col-md-6 col-xl-4">
          <div
            class="card border-0"
            :style="{
              backgroundColor: totalNoAptos === 0 ? '#28a745' : 'red',
            }"
          >
            <!----><!---->
            <div class="card-body">
              <!----><!---->
              <div class="row">
                <div class="col">
                  <h2 class="card-title text-uppercase mb-0 text-white">
                    NO APTOS
                  </h2>
                  <span class="h2 font-weight-bold mb-0 text-white">
                    {{ totalNoAptos }}/{{ totalActivos }}
                  </span>
                </div>
                <base-button
                  size="sm"
                  type="secondary"
                  style="height: 50%"
                  @click="onNoAptoClick(false)"
                  >Solucionar</base-button
                >
              </div>
              <div class="wrapper progress-xs mt-3 mb-0">
                <div class="progress bg-white" size="" style="height: 4px">
                  <div
                    role="progressbar"
                    aria-valuemin="0"
                    :aria-valuenow="
                      totalActivos
                        ? Math.floor((totalNoAptos * 100) / totalActivos)
                        : 0
                    "
                    class="progress-bar bg-success"
                    :style="{
                      width: totalActivos
                        ? Math.floor((totalNoAptos * 100) / totalActivos) + '%'
                        : '0%',
                    }"
                  ></div>
                </div>
              </div>
              <p class="mt-3 mb-0 text-sm">
                <a href="#!" class="text-white font-weight-600"
                  >Estos equipos necesitan atención.</a
                >
              </p>
            </div>
            <!----><!---->
          </div>
        </div>

        <!-- CARD REVISION CADUCADA -->
        <div class="col-md-6 col-xl-4">
          <div
            class="card border-0"
            :style="{
              backgroundColor: totalCaducados === 0 ? '#28a745' : 'red',
            }"
          >
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h2 class="card-title text-uppercase mb-0 text-white">
                    REVISIÓN CADUCADA
                  </h2>
                  <span class="h2 font-weight-bold mb-0 text-white">
                    {{ totalCaducados }}/{{ totalActivos }}
                  </span>
                </div>
                <base-button
                  size="sm"
                  type="secondary"
                  style="height: 50%"
                  @click="onNoAptoClick(false)"
                  >Revisar</base-button
                >
              </div>
              <div class="wrapper progress-xs mt-3 mb-0">
                <div class="progress bg-white" size="" style="height: 4px">
                  <div
                    role="progressbar"
                    aria-valuemin="0"
                    :aria-valuenow="
                      totalActivos
                        ? Math.floor((totalCaducados * 100) / totalActivos)
                        : 0
                    "
                    class="progress-bar bg-success"
                    :style="{
                      width: totalActivos
                        ? Math.floor((totalCaducados * 100) / totalActivos) +
                          '%'
                        : '0%',
                    }"
                  ></div>
                </div>
              </div>
              <p class="mt-3 mb-0 text-sm">
                <a href="#!" class="text-white font-weight-600"
                  >Necesitan una revisión urgente.</a
                >
              </p>
            </div>
          </div>
        </div>

        <!-- CARD REVISIÓN PRÓXIMA -->
        <div class="col-md-6 col-xl-4">
          <div
            class="card border-0"
            :style="{ backgroundColor: totalCaducan === 0 ? '#28a745' : 'red' }"
          >
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h2 class="card-title text-uppercase mb-0 text-white">
                    REVISIÓN PRÓXIMA
                  </h2>
                  <span class="h2 font-weight-bold mb-0 text-white">
                    {{ totalCaducan }}/{{ totalActivos }}
                  </span>
                </div>
                <base-button
                  size="sm"
                  type="secondary"
                  style="height: 50%"
                  @click="onNoAptoClick(false)"
                  >Planificar</base-button
                >
              </div>
              <div class="wrapper progress-xs mt-3 mb-0">
                <div class="progress bg-white" size="" style="height: 4px">
                  <div
                    role="progressbar"
                    aria-valuemin="0"
                    :aria-valuenow="
                      totalActivos
                        ? Math.floor((totalCaducan * 100) / totalActivos)
                        : 0
                    "
                    class="progress-bar bg-success"
                    :style="{
                      width: totalActivos
                        ? Math.floor((totalCaducan * 100) / totalActivos) + '%'
                        : '0%',
                    }"
                  ></div>
                </div>
              </div>
              <p class="mt-3 mb-0 text-sm">
                <a href="#!" class="text-white font-weight-600"
                  >Estos equipos en 3 meses.</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-3">
          <card>
            <template slot="header">
              <!-- Subtitle -->
              <h6 class="surtitle">TODOS LOS EQUIPOS</h6>
              <!-- Title -->
              <h5 class="h3 mb-0">Aptos vs No aptos</h5>
            </template>
            <div class="chart">
              <pie-chart
                id="pie-chart"
                ref="pieChart"
                :height="350"
                :chart-data="pieChart.chartData"
                :extra-options="pieChart.extraOptions"
              >
              </pie-chart>
            </div>
          </card>
        </div>

        <div class="col-xl-9">
          <card>
            <template slot="header">
              <!-- Subtitle -->
              <h6 class="surtitle">REVISIÓN PRÓXIMA</h6>
              <!-- Title -->
              <h5 class="h3 mb-0">Revisiones que caducan en el próximo año</h5>
            </template>
            <div align="center" v-if="loadingChartMonths">
              <img src="/img/loading.gif" style="height: 100px; width: 100px" />
            </div>
            <bar-chart
              :height="350"
              ref="barChart"
              :chart-data="redBarChart.chartData"
            >
            </bar-chart>
          </card>
        </div>
      </div>

      <!-- <div class="row">
        <div class="col-xl-12">
          <card>
            <template slot="header">
          
              <h6 class="surtitle">REVISIÓN PRÓXIMA GLOBAL</h6>
             
              <h5 class="h3 mb-0">Revisiones que caducan en el próximo año</h5>
            </template>
            <div align="center" v-if="loadingChartMonths">
              <img src="/img/loading.gif" style="height: 100px; width: 100px" />
            </div>

              <div class="chart-area">
              <bar-chart
                :height="350"
                :chart-data="barChartStacked.chartData"
                :extra-options="barChartStacked.extraOptions"
              >
              </bar-chart>
            </div> 
          </card>
        </div>
      </div> -->

      <!-- CARDS -->
      <div class="row pt-4">
        <div
          class="col-xl-3 col-md-6"
          @click="goToListadoEquipos()"
          style="cursor: pointer"
        >
          <stats-card-img
            title="Todos los Equipos"
            type="gradient-orange"
            :sub-title="totalActivos ? totalActivos.toString() : '0'"
          >
            <template slot="footer">
              <span class="text-success mr-2"
                >{{
                  totalEPIS
                    ? Math.round((totalActivos * 100) / totalActivos)
                    : "0"
                }}%</span
              >
              <span class="text-nowrap">de los equipos</span>
            </template>
          </stats-card-img>
        </div>
        <div
          class="col-xl-3 col-md-6"
          @click="goToListadoEpis()"
          style="cursor: pointer"
        >
          <stats-card-img
            title="EPIS"
            type="gradient-orange"
            :sub-title="totalEPIS ? totalEPIS.toString() : '0'"
          >
            <template slot="footer">
              <span class="text-success mr-2"
                >{{
                  totalEPIS
                    ? Math.round((totalEPIS * 100) / totalActivos)
                    : "0"
                }}%</span
              >
              <span class="text-nowrap">de los equipos</span>
            </template>
          </stats-card-img>
        </div>
        <div
          class="col-xl-3 col-md-6"
          @click="goToListadoHerramientas()"
          style="cursor: pointer"
        >
          <stats-card-img
            title="HERRAMIENTAS"
            type="gradient-green"
            :sub-title="totalHerramientas ? totalHerramientas.toString() : '0'"
          >
            <template slot="footer">
              <span class="text-success mr-2"
                >{{
                  totalHerramientas
                    ? Math.floor((totalHerramientas * 100) / totalActivos)
                    : "0"
                }}%</span
              >
              <span class="text-nowrap">de los equipos</span>
            </template>
          </stats-card-img>
        </div>
        <div
          class="col-xl-3 col-md-6"
          @click="goToListadoAnclajes()"
          style="cursor: pointer"
        >
          <stats-card-img
            title="DISPOSITIVOS DE ANCLAJE"
            type="gradient-green"
            :sub-title="
              totalDispositivosDeAnclaje
                ? totalDispositivosDeAnclaje.toString()
                : '0'
            "
          >
            <template slot="footer">
              <span class="text-success mr-2"
                >{{
                  totalDispositivosDeAnclaje
                    ? Math.floor(
                        (totalDispositivosDeAnclaje * 100) / totalActivos
                      )
                    : "0"
                }}%</span
              >
              <span class="text-nowrap">de los equipos</span>
            </template>
          </stats-card-img>
        </div>
      </div>
      <!-- CARDS CON LOS ESTADOS DE LOS EQUIPOS:-->
      <div v-if="perteneceSalvador" class="row">
        <div class="col-xl-3 col-md-6">
          <button
            class="btn btn-primary"
            @click="loadTableData"
            :disabled="loadingButton"
          >
            <span v-if="loadingButton">
              <i class="fas fa-spinner fa-spin"></i> Cargando...
            </span>
            <span v-else>TABLA GLOBAL REVISIONES</span>
          </button>
        </div>
      </div>

      <!--  TABLA GLOBAL -->
      <div v-if="mostrarTabla" class="row">
        <div class="col-xl-12">
          <card
            class="no-border-card"
            body-classes="px-0 pb-1"
            footer-classes="pb-2"
          >
            <template slot="header">
              <!-- Subtitle -->
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="surtitle">REVISIÓN PRÓXIMA GLOBAL</h6>
                  <!-- Title -->
                  <h5 class="h3 mb-0">Revisiones que caducan en el próximo año</h5>
                </div>
                <base-button
                  size="sm"
                  type="neutral"
                  @click="exportRevisionesToExcel"
                  :loading="exporting"
                  :disabled="!filteredRevisionesData || filteredRevisionesData.length === 0"
                >
                  <i class="fas fa-file-excel mr-1"></i>
                  Exportar a Excel
                </base-button>
              </div>
            </template>
            <div class="p-2">
              <div
                class="row col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div class="col-md-4">
                  <div>
                    <form>
                      <base-input
                        v-model="query"
                        type="search"
                        prepend-icon="fas fa-search"
                        placeholder="Buscar por empresa..."
                        clearable
                      />
                    </form>
                  </div>
                </div>
                <!-- Selector de filtro a la derecha -->
                <div class="col-md-3 d-flex justify-content-end">
                  <el-select
                    v-model="divisionFilter"
                    placeholder="Todos"
                    @change="onDivisionChange"
                    style="min-width: 200px"
                  >
                    <el-option label="Todos" value=""></el-option>
                    <el-option label="EPIS" value="EPIS"></el-option>
                    <el-option
                      label="HERRAMIENTAS"
                      value="HERRAMIENTAS"
                    ></el-option>
                    <el-option
                      label="DISPOSITIVOS DE ANCLAJE"
                      value="DISPOSITIVOS DE ANCLAJE"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <template>
                <div>
                  <el-table
                    ref="revisionesTable"
                    class="table-responsive align-items-center table-flush"
                    header-row-class-name="thead-light"
                    :data="filteredRevisionesData"
                    :default-sort="{
                      prop: 'mesMasCercano',
                      order: 'ascending',
                    }"
                    empty-text="No hay datos de revisiones disponibles"
                  >
                    <!-- LOADING -->
                    <div slot="empty" v-if="loading">
                      <img
                        src="/img/loading.gif"
                        style="height: 100px; width: 100px"
                      />
                    </div>

                    <!-- Nombre de la empresa -->
                    <el-table-column
                      label="Empresa"
                      prop="empresa"
                      min-width="250px"
                    >
                      <template slot-scope="{ row }">
                        <b>{{ row.empresa }}</b>
                      </template>
                    </el-table-column>

                    <!-- Revisiones por Mes -->
                    <el-table-column
                      v-for="(mes, index) in meses"
                      :key="index"
                      :label="mes"
                      :prop="'revisionesPorMes[' + index + ']'"
                      :min-width="100"
                    >
                      <template slot-scope="{ row }">
                        <span>{{ row.revisionesPorMes[index] }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </div>

            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="row">
                <div class="col-xl-4">
                  <el-select
                    class="select-primary pagination-select"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div class="col-xl-8">
                  <p class="card-category" style="margin-top: 0.5rem">
                    Mostrando {{ total ? from + 1 : 0 }} - {{ to }} de
                    {{ total }} registros

                    <span v-if="selectedRows.length">
                      &nbsp; &nbsp; {{ selectedRows.length }} rows selected
                    </span>
                  </p>
                </div>
              </div>

              <base-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              />
            </div>
          </card>
        </div>
      </div>
    </base-header>
    <!--Classic modal-->
    <modal :show.sync="showNoAptoModal">
      <h6 slot="header" class="modal-title">Type your modal title</h6>

      <p>
        Esta opción de momento no está disponible, estamos trabajando para que
      </p>
      <p>
        A small river named Duden flows by their place and supplies it with the
        necessary regelialia. It is a paradisematic country, in which roasted
        parts of sentences fly into your mouth.
      </p>

      <template slot="footer">
        <base-button type="primary">Save changes</base-button>
        <base-button type="link" class="ml-auto" @click="onNoAptoClick(false)"
          >Close</base-button
        >
      </template>
    </modal>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";

// Charts
import * as chartConfigs from "@/components/Charts/config";
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import PieChart from "@/components/Charts/PieChart";

// Components
import BaseProgress from "@/components/BaseProgress";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import StatsCard from "@/components/Cards/StatsCard";
import { Charts } from "@/components/Charts/config";

// Lists
import ActivityFeed from "./ActivityFeed";
import TaskList from "./TaskList";
import UserList from "./UserList";
import ProgressTrackList from "./ProgressTrackList";

// Tables
import LightTable from "./LightTable";
import SocialTrafficTable from "./SocialTrafficTable";
import PageVisitsTable from "./PageVisitsTable";

import { BasePagination, TimeLine, TimeLineItem, Modal } from "@/components";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import moment from "moment";
import "moment/locale/es"; // without this line it didn't work
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
moment.locale("es");

function randomScalingFactor() {
  return Math.round(Math.random() * 100);
}

export default {
  components: {
    /*  ActivityFeed,
    LineChart, */
    BarChart,
    PieChart,
    Modal,
    /*  RouteBreadCrumb,
    BaseProgress,
    StatsCard,
    TaskList,
    PageVisitsTable,
    SocialTrafficTable,
    LightTable,
    UserList,
    ProgressTrackList,
    BasePagination,
    TimeLine,
    TimeLineItem,
    */
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
  },
  data() {
    return {
      redBarChart: {
        chartData: {
          labels: [],
          datasets: [
            {
              label: "EPIs",
              backgroundColor: Charts.colors.theme["danger"],
              data: [],
            },
            {
              label: "HERRAMIENTAS",
              backgroundColor: Charts.colors.theme["primary"],
              data: [],
            },
            {
              label: "DISPOSITIVOS DE ANCLAJE",
              backgroundColor: Charts.colors.theme["success"],
              data: [],
            },
          ],
        },
        extraOptions: chartConfigs.blueChartOptions,
      },
      pieChart: {
        chartData: {
          labels: ["APTOS", "NO APTOS"],
          datasets: [
            {
              data: [],
              backgroundColor: [],
              label: "Estado Equipos",
            },
          ],
        },
        extraOptions: {
          responsive: true,
          legend: {
            position: "top",
          },
          animation: {
            animateScale: true,
            animateRotate: true,
          },
        },
      },

      /*  barChartStacked: {
        chartData: {
          labels: [],
          datasets: [
            {
              label: "EPIs",
              backgroundColor: Charts.colors.theme["danger"],
              data: [
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
              ],
            },
            {
              label: "HERRAMIENTAS",
              backgroundColor: Charts.colors.theme["primary"],
              data: [
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
              ],
            },
            {
              label: "DISPOSITIVOS DE ANCLAJE",
              backgroundColor: Charts.colors.theme["success"],
              data: [
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
              ],
            },
          ],
        },
        extraOptions: {
          tooltips: {
            mode: "index",
            intersect: false,
          },
          responsive: true,
          scales: {
            xAxes: [
              {
                stacked: true,
              },
            ],
            yAxes: [
              {
                stacked: true,
              },
            ],
          },
        },
      }, */

      totalIncidencia: 0,
      totalCaducados: 0,
      totalCaducan: 0,
      totalAptos: 0,
      totalActivos: 0,
      totalEmpleados: 0,
      totalAptosAVigilar: 0,
      totalNoAptos: 0,
      totalEPIS: 0,
      totalHerramientas: 0,
      totalDispositivosDeAnclaje: 0,

      loading: true,

      query: null,
      selectedRows: [],
      sort: "createdAt:desc",
      total: 0,
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [25, 50, 100],
      },

      totalTablaIncidencias: 0,
      totalIncidencias: 0,

      users: [],
      user: null,
      revisionesData: [],
      meses: [],
      perteneceSalvador: false, // Variable para controlar la visibilidad de la tabla
      mostrarTabla: false,
      loadingButton: false, // Estado del botón de carga
      exporting: false, // Estado del botón de exportación
      filtroDivision: "todos", // Valor por defecto
      divisiones: [
        { label: "Todos", value: "todos" },
        { label: "EPIs", value: "epis" },
        { label: "Herramientas", value: "herramientas" },
        { label: "Líneas de vida", value: "lineas-vida" },
      ],

      incidencias: [],

      notificaciones: [],
      notificacionesEnv: [],

      loadingIncidenciaCard: true,
      loadingChartMonths: true,
      dashboardCompleted: false,
      showNoAptoModal: false,
    };
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    toIncidencias() {
      let highBound = this.from + this.pagination.perPage;
      if (this.totalIncidencias < highBound) {
        highBound = this.totalIncidencias;
      }
      return highBound;
    },
    filteredRevisionesData() {
      let filteredData = this.revisionesData;

      // Filtrar por la división seleccionada
      if (this.filtroDivision !== "todos") {
        filteredData = filteredData.filter((item) => {
          return (
            item.division && item.division.toLowerCase() === this.filtroDivision
          );
        });
      }

      // Aplicar búsqueda por nombre de empresa
      if (this.query) {
        const searchTerm = this.query.toLowerCase();
        filteredData = filteredData.filter((item) =>
          item.empresa.toLowerCase().includes(searchTerm)
        );
      }

      return filteredData;
    },
  },
  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    /*   estado: {
      handler: "getListDebounced",
      immediate: true,
    }, */
    pagination: {
      handler: "fetchEmpleadosData",
      immediate: false,
      deep: true,
    },
  },
  methods: {
    async checkIfUserBelongsToSalvador() {
      await this.$store.dispatch("profile/me");
      const user = await this.$store.getters["profile/me"];
      console.log("USUARIO: ", user);

      // Comprobar si el usuario pertenece a "SALVADOR SEGURIDAD EN ALTURA"
      const empresas = Array.isArray(user.empresas) ? user.empresas : [];
      this.perteneceSalvador = empresas.some(
        (elemento) => elemento.id_cliente_erp === "00001001"
      );
    },
    getListDebounced: _.debounce(function () {
      try {
        const idEmpresa = localStorage.getItem("plantaSelected");
        //this.getList();
        this.fetchDashboardData(idEmpresa);
        //this.fetchRevisorTableData();
      } catch (error) {
        this.refreshPage();
      }
    }, 500),

    goToListadoEquipos(estado) {
      this.$router.push({ name: "List Activo", query: { filter: estado } });
    },
    goToListadoHerramientas(estado) {
      this.$router.push({
        name: "List Herramienta",
        query: { filter: estado },
      });
    },
    goToListadoEpis(estado) {
      this.$router.push({ name: "List Epi", query: { filter: estado } });
    },
    goToListadoAnclajes(estado) {
      this.$router.push({ name: "List Anclaje", query: { filter: estado } });
    },
    goToListadoRetirados(estado) {
      this.$router.push({ name: "List Retirado", query: { filter: estado } });
    },
    onNoAptoClick(show) {
      this.showNoAptoModal = show;
    },
    async fetchDashboardData(idEmpresa) {
      axios
        .get(
          `https://misepis-api.delfromsoftware.com/api/dashboard?idEmpresa=${idEmpresa}`
        )
        .then((response) => {
          const kpis = response.data.stats;
          const revisionesPorMes = response.data.revisionesPorMes;
          const activosPorDivision = response.data.activosPorDivision;

          console.log("KPIs: ", kpis);
          console.log("revisionesPorMes: ", revisionesPorMes);
          console.log("activosPorDivision: ", activosPorDivision);

          // KPIs
          this.totalAptos = kpis.aptos;
          this.totalAptosAVigilar = kpis.aptosAVigilar;
          this.totalNoAptos = kpis.noAptos;
          this.totalCaducados = kpis.revisionCaducada;
          this.totalCaducan = kpis.revisionProxima;
          this.totalActivos = kpis.total;

          // Activos por división
          this.totalEPIS = activosPorDivision.EPIS;
          this.totalHerramientas = activosPorDivision.HERRAMIENTAS;
          this.totalDispositivosDeAnclaje =
            activosPorDivision.DISPOSITIVOS_DE_ANCLAJE;

          // Actualización del gráfico de revisiones por mes
          var datas = {
            label: "Equipos",
            data: revisionesPorMes,
            backgroundColor: Charts.colors.theme["danger"],
          };

          var dataPiChart = {
            data: [
              Math.floor(
                this.totalAptos + this.totalAptosAVigilar + this.totalCaducan
              ),
              Math.floor(this.totalNoAptos + this.totalCaducados),
            ],
            backgroundColor: [
              Charts.colors.theme["success"],
              Charts.colors.theme["danger"],
            ],
            label: "Estado Equipos",
          };

          console.log("PIECHART DATA: ", dataPiChart);
          console.log("BARCHART: ", datas);

          Vue.set(this.redBarChart.chartData.datasets, 0, datas);
          this.$refs.barChart.$data._chart.update();
          Vue.set(this.pieChart.chartData.datasets, 0, dataPiChart);
          this.$refs.pieChart.$data._chart.update();

          this.loadingChartMonths = false;
          this.dashboardCompleted = true;
        })
        .catch((error) =>
          console.error("Error fetching dashboard data:", error)
        );
    },

    async loadTableData() {
      try {
        this.loadingButton = true;
        const response = await axios.get(
          "https://misepis-api.delfromsoftware.com/api/dashboard/revisor"
        );
        this.revisionesData = response.data.data;
        this.meses = response.data.meses.map((mes) =>
          moment(mes, "MMMM YYYY").format("MMM YY").toUpperCase()
        );
        console.log("asadfojasdofj");
        this.mostrarTabla = true; // Mostrar tabla solo después de cargar los datos
      } catch (error) {
        console.error("Error al cargar datos:", error);
      } finally {
        this.loadingButton = false;
      }
    },
    async fetchRevisorTableData() {
      this.isLoading = true;
      this.error = null;

      await this.$store.dispatch("profile/me");
      const user = await this.$store.getters["profile/me"];
      console.log("USUARIO: ", user);

      // Comprobar si el usuario pertenece a "SALVADOR SEGURIDAD EN ALTURA"
      const empresas = Array.isArray(user.empresas) ? user.empresas : [];
      this.perteneceSalvador = empresas.some(
        (elemento) => elemento.id_cliente_erp === "00001001"
      );

      console.log("USUARIO PERTENECE A SALVADOR: ", this.perteneceSalvador);
      if (!this.perteneceSalvador) return;

      try {
        const response = await axios.get(
          "https://misepis-api.delfromsoftware.com/api/dashboard/revisor"
        );

        this.revisionesData = response.data.data;
        const mesesData = response.data.meses;
        // Convertir los meses al formato "DIC 24", "ENE 25"
        this.meses = mesesData.map((mes) =>
          moment(mes, "MMMM YYYY").format("MMM YY").toUpperCase()
        );

        console.log(this.revisorTableData);
        console.log(this.revistorTableMeses);
        this.loading = false;
      } catch (err) {
        this.error = "Error al cargar los datos del dashboard.";
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    viewDetails(row) {
      console.log("Detalles de la empresa:", row);
      // Aquí puedes navegar a otra vista o mostrar un modal con más detalles
    },

    async exportRevisionesToExcel() {
      try {
        this.exporting = true;

        if (!this.filteredRevisionesData || this.filteredRevisionesData.length === 0) {
          this.$notify({
            type: "warning",
            message: "No hay datos para exportar.",
          });
          return;
        }

        // Preparar datos para Excel
        const data = this.filteredRevisionesData.map((row) => {
          const rowData = {
            EMPRESA: row.empresa || '',
          };

          // Añadir cada mes como columna
          this.meses.forEach((mes, index) => {
            rowData[mes] = row.revisionesPorMes && row.revisionesPorMes[index] !== undefined 
              ? row.revisionesPorMes[index] 
              : 0;
          });

          return rowData;
        });

        // Generar nombre del archivo con fecha actual
        const fechaActual = moment().format('YYYY-MM-DD');
        const nombreXLS = `REVISIONES_PROXIMO_ANO_${fechaActual}.xlsx`;

        // Crear workbook
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Revisiones");

        // Definir encabezados
        const headers = [
          { header: "EMPRESA", key: "EMPRESA", width: 30 },
          ...this.meses.map((mes) => ({
            header: mes,
            key: mes,
            width: 15,
          })),
        ];

        worksheet.columns = headers;

        // Estilo del encabezado
        worksheet.getRow(1).eachCell((cell) => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FF0070C0" },
          };
          cell.font = { color: { argb: "FFFFFFFF" }, bold: true };
          cell.alignment = { vertical: "middle", horizontal: "center" };
        });

        // Añadir filas
        data.forEach((row) => {
          const excelRow = worksheet.addRow(row);
          
          // Centrar números de revisiones
          this.meses.forEach((mes) => {
            const cell = excelRow.getCell(mes);
            cell.alignment = { vertical: "middle", horizontal: "center" };
            if (cell.value !== undefined && cell.value !== null) {
              cell.numFmt = "0"; // Formato numérico sin decimales
            }
          });
        });

        // Añadir fila de totales al final
        if (data.length > 0) {
          const totalRow = worksheet.addRow({});
          totalRow.getCell("EMPRESA").value = "TOTAL";
          totalRow.getCell("EMPRESA").font = { bold: true };
          totalRow.getCell("EMPRESA").fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFE0E0E0" },
          };

          this.meses.forEach((mes) => {
            const total = data.reduce((sum, row) => {
              return sum + (row[mes] || 0);
            }, 0);
            const cell = totalRow.getCell(mes);
            cell.value = total;
            cell.font = { bold: true };
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFE0E0E0" },
            };
            cell.alignment = { vertical: "middle", horizontal: "center" };
            cell.numFmt = "0";
          });
        }

        // Generar buffer y descargar
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, nombreXLS);

        this.$notify({
          type: "success",
          message: "Datos exportados correctamente.",
        });
      } catch (error) {
        console.error("Error al exportar:", error);
        this.$notify({
          type: "danger",
          message: "Error al exportar los datos.",
        });
      } finally {
        this.exporting = false;
      }
    },

    async fetchEmpleadosData(idEmpresa) {
      this.loading = true;
      await this.$store
        .dispatch("users/fetchEmpleados", {
          idEmpresa: idEmpresa,
          search: this.query,
        })
        .then(() => {
          this.users = this.$store.getters["users/empleados"];
          const kpis = this.$store.getters["users/kpis"];

          /* LISTADO DE EMPLEADOS */
          this.users = empleados;
          this.totalEmpleados = kpis.total;
        })
        .catch((error) =>
          console.error("Error fetching dashboard data:", error)
        );
      this.loading = false;
    },

    async getListIncidencias(idEmpresa) {
      var filters = {
        $and: [
          {
            activo: {
              empresa: {
                id: { $in: idEmpresa },
              },
            },
          },
          { $or: [] },
        ],
      };

      let params = {
        ...(this.sort ? { sort: this.sort } : {}),

        filters: filters,
        pagination: {
          page: this.pagination.currentPage,
          pageSize: this.pagination.perPage,
        },
      };

      await this.$store
        .dispatch("incidencias/list", params)
        .then(() => {
          this.incidencias = this.$store.getters["incidencias/list"];

          this.totalIncidencia = this.$store.getters["incidencias/listTotal"];
          if (this.totalIncidencia > this.totalTablaIncidencias) {
            this.totalTablaIncidencias = this.totalIncidencia;
          }
        })
        .catch((error) => {
          console.log("ERROR EN LA LLAMADA: ", error);
          this.refreshPage();
        });

      this.loading = false;
    },

    async getListNotifRecived() {
      await this.$store.dispatch("profile/me");
      let profile = await this.$store.getters["profile/me"];
      console.log(profile);
      let params = {
        filters: {
          usuario_destinos: {
            id: { $in: profile.id },
          },
        },
        pagination: {
          page: 1,
          pageSize: 3,
        },
      };
      await this.$store
        .dispatch("notificaciones/list", params)
        .then(() => {
          this.notificaciones = this.$store.getters["notificaciones/list"];

          console.log(this.notificaciones);
        })
        .catch((error) => {
          console.log("ERROR EN LA LLAMADA: ", error);
          this.refreshPage();
        });
      this.loading = false;
    },

    async getListNotifSent() {
      await this.$store.dispatch("profile/me");
      let profile = await this.$store.getters["profile/me"];

      let params = {
        filters: {
          usuario_origen: {
            id: { $in: profile.id },
          },
        },
        pagination: {
          page: 1,
          pageSize: 3,
        },
      };
      await this.$store
        .dispatch("notificaciones/list", params)
        .then(() => {
          this.notificacionesEnv = this.$store.getters["notificaciones/list"];

          console.log("NOTIFICACIONES ENVIADAS:");
          console.log(this.notificacionesEnv);
        })
        .catch((error) => {
          console.log("ERROR EN LA LLAMADA: ", error);
          this.refreshPage();
        });
      this.loading = false;
    },
    async getProfile() {
      try {
        await this.$store.dispatch("profile/me");
        this.user = await { ...this.$store.getters["profile/me"] };
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Sesión caducada.",
        });
        this.logout();
      }
    },
    viewTipo(row) {
      console.log(row);
      this.$router.push({
        name: "View incidencia",
        params: { id: row.id },
      });
    },
    refreshPage() {
      console.log("refreshPage");
      location.reload(); // Reloads the current page
    },
    downloadTipo(row) {
      console.log(row);

      const url_adicional = row.pdf;

      console.log(url_adicional);

      if (url_adicional) {
        window.open(url_adicional, "_blank");
      } else {
        this.$notify({
          type: "danger",
          message: `No se puede abrir el documento`,
        });
      }
    },

    addDays(result, days) {
      result.setDate(result.getDate() + days);
      return result;
    },
    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `-${prop}`;
      } else {
        this.sort = `${prop}`;
      }
      this.fetchEmpleadosData();
    },
    async editUser(row) {
      this.$router.push({
        name: "Edit User",
        params: { id: row.id },
      });
    },
  },
  created() {
    this.checkIfUserBelongsToSalvador();
    console.log(moment().startOf("month").format("MMM"));
    var month1 = moment().startOf("month").format("MMM");
    var month2 = moment().add(1, "month").startOf("month").format("MMM");
    var month3 = moment().add(2, "month").startOf("month").format("MMM");
    var month4 = moment().add(3, "month").startOf("month").format("MMM");
    var month5 = moment().add(4, "month").startOf("month").format("MMM");
    var month6 = moment().add(5, "month").startOf("month").format("MMM");
    var month7 = moment().add(6, "month").startOf("month").format("MMM");
    var month8 = moment().add(7, "month").startOf("month").format("MMM");
    var month9 = moment().add(8, "month").startOf("month").format("MMM");
    var month10 = moment().add(9, "month").startOf("month").format("MMM");
    var month11 = moment().add(10, "month").startOf("month").format("MMM");
    var month12 = moment().add(11, "month").startOf("month").format("MMM");

    this.redBarChart.chartData.labels.push(month1);
    this.redBarChart.chartData.labels.push(month2);
    this.redBarChart.chartData.labels.push(month3);
    this.redBarChart.chartData.labels.push(month4);
    this.redBarChart.chartData.labels.push(month5);
    this.redBarChart.chartData.labels.push(month6);
    this.redBarChart.chartData.labels.push(month7);
    this.redBarChart.chartData.labels.push(month8);
    this.redBarChart.chartData.labels.push(month9);
    this.redBarChart.chartData.labels.push(month10);
    this.redBarChart.chartData.labels.push(month11);
    this.redBarChart.chartData.labels.push(month12);

    /*     this.barChartStacked.chartData.labels.push(month1);
    this.barChartStacked.chartData.labels.push(month2);
    this.barChartStacked.chartData.labels.push(month3);
    this.barChartStacked.chartData.labels.push(month4);
    this.barChartStacked.chartData.labels.push(month5);
    this.barChartStacked.chartData.labels.push(month6);
    this.barChartStacked.chartData.labels.push(month7);
    this.barChartStacked.chartData.labels.push(month8);
    this.barChartStacked.chartData.labels.push(month9);
    this.barChartStacked.chartData.labels.push(month10);
    this.barChartStacked.chartData.labels.push(month11);
    this.barChartStacked.chartData.labels.push(month12); */
  },
  mounted() {
    // 2. The DOM is ready to go now
    this.getListDebounced();

    // Asegúrate de realizar la actualización del gráfico cuando esté disponible
    Vue.nextTick(() => {
      if (
        this.$refs.pieChart &&
        this.$refs.pieChart.$data &&
        this.$refs.pieChart.$data._chart
      ) {
        this.$refs.pieChart.$data._chart.update();
      } else {
        console.error(
          "Pie chart reference is still undefined or chart object not ready."
        );
      }
    });
  },
};
</script>
<style scoped>
.kpi-container {
  display: flex;
  justify-content: space-between; /* Espacio equitativo entre los elementos */
  align-items: center; /* Centra verticalmente los elementos */
  flex-wrap: wrap; /* Permite que los elementos pasen a otra fila si es necesario */
  gap: 20px; /* Espacio entre elementos */
}

.kpi-item {
  flex: 1 1 calc(20% - 20px); /* Cada KPI ocupa el 20% del ancho, ajustado por el gap */
  max-width: calc(20% - 20px);
}
.table-responsive {
  width: 100%;
  overflow-x: auto;
}

.thead-light {
  background-color: #f8f9fa;
}

.table-flush {
  border-collapse: collapse;
}
</style>
